$(document).ready(function () {
  $('.notification').on('click', function () {
      $(this).slideToggle();
  });
});